'use client';
import React from 'react';
import Link from 'next/link';
import {
  UtensilsCrossed,
  Stethoscope,
  GraduationCap,
  Scale,
  Building2,
  ShoppingBag,
  Laptop,
  Rocket,
  Users,
  Briefcase,
  ArrowRight,
} from 'lucide-react';

export const TTOSIndustrySelector: React.FC = () => {
  const industries = [
    {
      name: 'Restaurant',
      icon: UtensilsCrossed,
      color: 'text-amber-600 bg-amber-50 border-amber-100',
    },
    {
      name: 'Doctor',
      icon: Stethoscope,
      color: 'text-emerald-600 bg-emerald-50 border-emerald-100',
    },
    {
      name: 'School',
      icon: GraduationCap,
      color: 'text-blue-600 bg-blue-50 border-blue-100',
    },
    {
      name: 'Lawyer',
      icon: Scale,
      color: 'text-purple-600 bg-purple-50 border-purple-100',
    },
    {
      name: 'Real Estate',
      icon: Building2,
      color: 'text-rose-600 bg-rose-50 border-rose-100',
    },
    {
      name: 'Retail',
      icon: ShoppingBag,
      color: 'text-orange-600 bg-orange-50 border-orange-100',
    },
    {
      name: 'Freelancer',
      icon: Laptop,
      color: 'text-indigo-600 bg-indigo-50 border-indigo-100',
    },
    {
      name: 'Startup',
      icon: Rocket,
      color: 'text-sky-600 bg-sky-50 border-sky-100',
    },
    {
      name: 'Agency',
      icon: Users,
      color: 'text-teal-600 bg-teal-50 border-teal-100',
    },
    {
      name: 'Professional',
      icon: Briefcase,
      color: 'text-slate-600 bg-slate-100 border-slate-200',
    },
  ];

  return (
    <section id="industries" className="py-16 bg-white border-t border-slate-100/80">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        
        {/* Section Heading (Matching Screenshot exactly) */}
        <div className="space-y-1.5 mb-10">
          <h2 className="text-2xl sm:text-3xl font-extrabold text-slate-900 tracking-tight">
            Choose Your Industry
          </h2>
          <p className="text-xs sm:text-sm text-slate-500 font-normal">
            TT OS will customize everything for your business
          </p>
        </div>

        {/* 10 Industry Cards in single clean row / responsive grid (Matching Screenshot) */}
        <div className="grid grid-cols-2 sm:grid-cols-5 lg:grid-cols-10 gap-3">
          {industries.map((ind, idx) => (
            <Link
              key={idx}
              href="#everything"
              className="group flex flex-col items-center justify-center p-3.5 rounded-2xl bg-white border border-slate-200/90 shadow-xs hover:border-indigo-300 hover:shadow-md transition-all duration-200 hover:-translate-y-0.5"
            >
              <div
                className={`w-11 h-11 rounded-2xl border flex items-center justify-center mb-2.5 shadow-xs transition-transform group-hover:scale-110 ${ind.color}`}
              >
                <ind.icon className="w-5 h-5" />
              </div>
              <span className="text-[12px] font-bold text-slate-800 group-hover:text-indigo-600 transition-colors">
                {ind.name}
              </span>
            </Link>
          ))}
        </div>

        {/* View All Industries Link (Matching Screenshot) */}
        <div className="mt-7">
          <Link
            href="#everything"
            className="inline-flex items-center gap-1.5 text-xs font-bold text-indigo-600 hover:text-indigo-800 group"
          >
            <span>View all industries</span>
            <ArrowRight className="w-3.5 h-3.5 group-hover:translate-x-0.5 transition-transform" />
          </Link>
        </div>

      </div>
    </section>
  );
};

export default TTOSIndustrySelector;
